import React from 'react';
import { Formik } from 'formik';
import { schema1 } from '../../extras/validation/schema';
import FromSignIn from './FromSignIn'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { loginUser } from '../../../../../store/actions/UserAction'
import { LAWYERS_CONTACTED } from '../../../../../routes';

const SignInClient = (props) => {

  const onSubmit = (values, { setSubmitting, setFieldError }) => {
    setSubmitting(false);

    if (
      props.role &&
      (props.role === 'lawFirm' ||
      props.role === 'lawyer')
    ) {
      setFieldError(
        'email',
        `Ya te encuentras autenticado como ${props.role === 'lawyer' ? 'abogado' : 'despacho'}.`
      )
    } else {
      props.loginUser(values.email, values.password, 'client')
        .then((res) => {
          props.history.push(LAWYERS_CONTACTED)
        })
        .catch(error => {
          let errorCode;
          if (error.code) {
            errorCode = error.code
          } else if (error.data.error) {
            errorCode = error.data.error.code
          }

          console.log(error)
          switch (errorCode) {
            case 'auth/user-not-found':
              setFieldError(
                'email',
                'No existe el usuario proporcionado.'
              )
              break;
            case 'auth/wrong-password':
              setFieldError(
                'email',
                'La contraseña o el usuario no es válido'
              )
              break;
            case 'auth/invalid-credential':
              setFieldError(
                'email',
                'La contraseña no o el usuario no es válido'
              )
              break;
            case 'auth/too-many-requests':
              setFieldError(
                'password',
                'Intente en unos minutos se alcanzo el limite de intentos fallidos'
              )
              break;
            case 'auth/invalid-user':
              setFieldError(
                'email',
                'El usuario no es válido'
              )
              break;
            case 'auth/invalid-role':
              setFieldError(
                'email',
                'El usuario no es válido'
              )
              break;
            default:
              break;
          }
        });
    }
    }

   /*  props.firebase.login({email: values.email, password: values.password})
      .then(snap => {
        if (snap.user.user && !snap.user.user.emailVerified) {
          props.history.push('/dashboard/');
        }
      })
      .catch(error => {
        switch (error.code) {
          case 'auth/user-not-found':
            return setErrors({ email: 'Esta cuenta no existe' });
          case 'auth/wrong-password':
            return setErrors({ password: 'Esta contraseña es incorrecta' });
          case 'auth/too-many-requests':
            return setErrors({
              password: 'Limite de intentos porfavor espere un momento'
            });
          default:
            return setErrors({ email: 'Ocurrió un error' });
        }
      });
  };
 */


  const initialValues = {
    email: '',
    password: ''
  };

  return ( 
    <Formik
      initialValues={initialValues}
      validationSchema={schema1}
      onSubmit={onSubmit}
      render={props => <FromSignIn {...props} />}
    />
  );
}

const mapStateToProps = state => ({
  authUser: state.sessionState.authUser,
  role: state.authClient.role,
});


const mapDispatchToProps = dispatch => ({
  loginUser: (email, password, roleAuth) => dispatch(loginUser(email, password, roleAuth)),
 /*  onSetSessionUser: status => */
});

 const SignInCompress = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(SignInClient);

export default SignInCompress;